import $ from 'jquery'
// import Vue from 'vue'
import Swiper from 'swiper'

export default {}

String.prototype.replaceAll = function(search, replacement) {
  let target = this
  return target.replace(new RegExp(search, 'g'), replacement)
}

/**
 * Vue event bus
 */
// export const EventBus = new Vue()

/**
 * format number follow currency
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_point
 * @returns {string}
 */
export function numberFormat(number, decimals, dec_point = '.', thousands_point = ',') {
  if (number == null || !isFinite(number)) throw new TypeError('number is not valid')

  if (!decimals) {
    let len = number.toString().split('.').length
    decimals = len > 1 ? len : 0
  }

  number = parseFloat(number).toFixed(decimals)

  number = number.replace(".", dec_point)

  let splitNum = number.split(dec_point)
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point)
  number = splitNum.join(dec_point)

  return number
}

/**
 * create download button
  * @param url
 * @returns {HTMLAnchorElement}
 */
export const createDownloadButton = (url = '') => {
  let element = document.createElement('a')
  element.setAttribute('href', url)
  element.setAttribute('download', '')

  element.style.display = 'none'
  document.body.appendChild(element)

  return element
}

/**
 * set same height
 * @param jQueryArr array of jQuery selector
 */
export const setSameHeight = (jQueryArr) => {
  // console.log('setSameHeight', jQueryArr)
  let maxHeight = 0
  // remove item height if isset
  jQueryArr.each((index, item) => {
    $(item).css('height', '')
  })
  // find max height
  jQueryArr.each((index, item) => {
    let itemOuterHeight = $(item).outerHeight()
    // console.log('itemHeight', itemOuterHeight)
    if (maxHeight < itemOuterHeight)
      maxHeight = itemOuterHeight
  })
  // console.log('maxHeight', maxHeight)
  // set height for each item
  jQueryArr.each((index, item) => {
    $(item).css('height', maxHeight + 'px')
  })
}

/**
 * generate product html base on product
 * @param product
 * @returns {string}
 */
export function generateProductHTML(product = null) {
  if (!product) return

  let html = ""
  html += `<div class="product" product-id="${product.id}">`
  html += `<div class="product__inner">`
  html += `<div class="product__thumbnail" style="background-image: url('${product.thumbnail}')">`
  html += `<a href="${product.url}"></a>`
  if (product.discount != 0) {
    html += `<span class="badge badge-discount">-${product.discount}%</span>`
  }
  html += `</div>`
  html += `<div class="product__content">`
  html += `<p class="product__title">${product.title}</p>`
  if (product.type === 'price') {    // show price
    if (product.discount != 0) {    // product has a discount
      html += `<a class="product__link" href="${product.url}">${numberFormat(product.discount_price)}đ</a>`
      html += `<a class="product__link price-disabled" href="${product.url}">${numberFormat(product.price)}đ</a>`
    } else {    // product doesn't have any discount
      html += `<a class="product__link" href="${product.url}">${numberFormat(product.price)}đ</a>`
    }
  } else {    // show normal btn
    html += `<a class="product__link" href="${product.url}">Xem giá</a>`
  }
  html += `</div></div></div>`

  return html
}

/**
 * initial slide
 * @param querySelector
 * @param slidesToShow
 * @param isArrows
 * @param dots
 * @param responsive
 * @param customOpts
 * @param isSetSameHeight
 * @returns {jQuery}
 */
export function initSlides(querySelector, slidesToShow = 1, isArrows = true, dots = false, responsive = [], customOpts = null, isSetSameHeight = true) {
  let opts = {
    lazyLoad: 'ondemand',
    // autoplay: true,
    autoplay: false,
    autoplaySpeed: 7000,
    slidesToShow: slidesToShow,
    arrows: false,
  }

  if (isArrows) {
    opts.arrows = true
    opts.prevArrow = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="icon-chevron-left"></span></button>'
    opts.nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="icon-chevron-right"></span></button>'
  }

  if (dots) opts.dots = dots

  if (responsive.length) opts.responsive = responsive

  if (customOpts) {
    for (let property in customOpts) {
      opts[property] = customOpts[property]
    }
  }

  let slider = querySelector.slick(opts)

  if (isSetSameHeight) {
    querySelector.on('setPosition', function () {
      $(this).find('.slick-slide').height('auto')
      let slickTrack = $(this).find('.slick-track')
      let slickTrackHeight = $(slickTrack).height()
      $(this).find('.slick-slide').css('height', slickTrackHeight + 'px')
    })
  }

  return slider
}

export function initSwiper(container, slidesPerView = 1, isArrows = true, dots = true, breakpoints = {}, customOpts = {}) {
  let opts = {
    loop: true,
    slidesPerView: slidesPerView,
    observer: true
  }

  if (isArrows)
    opts.navigation = {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }

  if (dots)
    opts.pagination = {
      el: '.swiper-pagination',
      type: 'bullets'
    }

  if (breakpoints) opts.breakpoints = breakpoints

  if (customOpts) {
    for (let property in customOpts) {
      opts[property] = customOpts[property]
    }
  }

  const swiper = new Swiper(container, opts)
  return swiper
}

(function($) {
  if ($.fn.style) {
    return;
  }

  // Escape regex chars with \
  let escape = function(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  };

  // For those who need them (< IE 9), add support for CSS functions
  let isStyleFuncSupported = !!CSSStyleDeclaration.prototype.getPropertyValue;
  if (!isStyleFuncSupported) {
    CSSStyleDeclaration.prototype.getPropertyValue = function(a) {
      return this.getAttribute(a);
    };
    CSSStyleDeclaration.prototype.setProperty = function(styleName, value, priority) {
      this.setAttribute(styleName, value);
      priority = typeof priority != 'undefined' ? priority : '';
      if (priority != '') {
        // Add priority manually
        let rule = new RegExp(escape(styleName) + '\\s*:\\s*' + escape(value) +
          '(\\s*;)?', 'gmi');
        this.cssText =
          this.cssText.replace(rule, styleName + ': ' + value + ' !' + priority + ';');
      }
    };
    CSSStyleDeclaration.prototype.removeProperty = function(a) {
      return this.removeAttribute(a);
    };
    CSSStyleDeclaration.prototype.getPropertyPriority = function(styleName) {
      let rule = new RegExp(escape(styleName) + '\\s*:\\s*[^\\s]*\\s*!important(\\s*;)?',
        'gmi');
      return rule.test(this.cssText) ? 'important' : '';
    }
  }

  // The style function
  $.fn.style = function(styleName, value, priority) {
    // DOM node
    let node = this.get(0);
    // Ensure we have a DOM node
    if (typeof node == 'undefined') {
      return this;
    }
    // CSSStyleDeclaration
    let style = this.get(0).style;
    // Getter/Setter
    if (typeof styleName != 'undefined') {
      if (typeof value != 'undefined') {
        // Set style property
        priority = typeof priority != 'undefined' ? priority : '';
        style.setProperty(styleName, value, priority);
        return this;
      } else {
        // Get style property
        return style.getPropertyValue(styleName);
      }
    } else {
      // Get CSSStyleDeclaration
      return style;
    }
  };
})($)

export const handleClickProductCatTypeMenuItem = e => {
  const $menuItem = $(e.target).closest('[data-product-cat-order]')
  const $mainNavigation = $menuItem.closest('.main-navigation')
  $mainNavigation.find('.menu').css('transform', '')
  $mainNavigation.find('.sub-menu.active').removeClass('active')
  $mainNavigation.hide()

  const productCatOrder = $menuItem.data('productCatOrder')
  if (productCatOrder === '') {
    window.location.href = $menuItem.attr('href')
    return
  }

  const $menuFilter = $('header .menu-filter')
  $menuFilter.show()
  $menuFilter.find('.close').addClass('active')
  $menuFilter.find(`.menu-filter-item[data-cat-order="${productCatOrder}"`).addClass('active')

  const $menuTrigger = $('header.site-header .menu-trigger')
  $menuTrigger.css('opacity', 0)
  $menuTrigger.children('.back').removeClass('active')
  $menuTrigger.children('.icon-close').toggleClass(('icon-close icon-bars')).removeClass('inactive')
  if (!$('.header-overlay').hasClass('active')) $('.header-overlay').addClass('active')
}

export const serialize = (obj, prefix) => {
  let str = []
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p]
      str.push((v !== null && typeof v === 'object') ?
        serialize(v, k) :
        encodeURIComponent(k) + '=' + encodeURIComponent(v))
    }
  }
  return str.join('&')
}
